import React from "react";
import GeneralException from "./components/Error/GeneralException";

interface IState {
  hasError: Boolean;
}

export default class ErrorBoundary extends React.Component<any, IState> {
  constructor(props: any) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(error: any) {
    return { hasError: true };
  }

  componentDidCatch(error: any, errorInfo: any) {}

  render() {
    if (this.state.hasError) {
      return <GeneralException />;
    }

    return this.props.children;
  }
}
